/* Javascript developed by Designers Friend Ltd. */;

let observed_pictures;
let observed_videos;
let observed_plxs;
let observed_carousels;
let handled_product;
let handled_collection;
let handled_search;
let handled_newsletter;
let observed_accordians;



let mod_menu;
let mod_underlines;
let cartHandler;
let mobile_state = -1;
const rootStyles = getComputedStyle(document.documentElement);
const dur = parseFloat(rootStyles.getPropertyValue('--dur')) * 1000; 


const deferred_events = function() {
    cartHandler = new handleCart();
    observed_videos = new observe_videos();
    observed_pictures = new observe_pictures();
    observed_plxs = new observe_plxs();
    mod_menu = new module_menu();
    mod_underlines = new module_underlines();
    observed_carousels = new observe_carousels()
    handled_collection = new handleCollection();
    handled_product = new handleProduct()
    handled_search = new handleSearch()
    handled_newsletter = new newsletterHandler()
    observed_accordians = new observe_accordians()

    // checkForForms();
};


const exit_events = function() {
    mobile_state = -1;
    observed_videos.disconnect();
    observed_pictures.disconnect();
    observed_plxs.disconnect();
    observed_carousels.disconnect()
    handled_product.disconnect()
    observed_accordians.disconnect()

    window.removeEventListener("resize", resize_events);
};

window.addEventListener("hashchange", function() {
    console.log('hashchange')
    window.scrollTo(0, 0);
    handled_collection.disconnect()
    handled_collection = new handleCollection();
}, false);


const resize_events = function() {

    if (mobile_state != is_mobile()){
        mobile_state = is_mobile();
        observed_carousels.reset()
    }
};

const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
};

const jumpToType = () => {
  const typeValue = getQueryParam("type");
  if (typeValue) {
    const targetElement = document.querySelector(`.product-type-banner[data-type="${typeValue}"]`);
    if (targetElement) {
      targetElement.scrollIntoView();
    }
  }
};

const init_events = function(run_deferred) {
    mobile_state = is_mobile();
    window.addEventListener("resize", resize_events);
    jumpToType()
    if (run_deferred){
        deferred_events();
    }
};

// window.onload=()=>{
//     deferred_events();
// }

let footer 

// Listen to all click events on the document
document.addEventListener('click', function (event) {

    if (event.target.closest('.footer.expanded > .footer__information ')){
        footer.classList.remove('expanded')
    }
    if (event.target.closest('.footer > .footer__information ')){
        footer.classList.add('expanded')
    }
    if (event.target.closest('.accordian-opener')){
        if (event.target.closest('.accordian-opener').classList.contains('active')){
            observed_accordians.close(event.target);
        }else{
            observed_accordians.open(event.target);
        }   
    }
    if (event.target.closest('.double-tap:not([data-state="tapped"])')){
        if (window.matchMedia('(pointer: coarse)').matches) {
            document.querySelectorAll('.double-tap').forEach(el => {el.dataSet.state="untapped"})
            event.preventDefault();
            event.target.dataSet.state="tapped";
        }
    }
});















document.addEventListener("DOMContentLoaded",function(){
init_events(true);
footer = document.querySelector('.footer')
});